import React, {useEffect, useState} from 'react';
import {FormattedMessage, useIntl} from "react-intl";
import {HttpStatus} from "../../../../modules/common/enums/HttpStatus";
import {MessageUtils} from "../../../../utils/MessageUtils";
import {Card, CardContent, CardHeader, Divider, List, ListItemButton, ListItemText, Stack,} from "@mui/material";
import {DepartmentDto} from "../../../../modules/account/dto/DepartmentDto";
import {DepartmentApi} from "../../../../modules/account/api/DepartmentApi";
import AddIconButton from "../../../../components/buttons/AddIconButton";
import DepartmentDetailDialog from "./components/DepartmentDetailDialog";
import {useConfirm} from "material-ui-confirm";
import RefreshIconButton from "../../../../components/buttons/RefreshIconButton";

export default function Index() {
    const intl = useIntl();

    const confirm = useConfirm();

    const [openDetailDialog, setOpenDetailDialog] = useState(false);
    const [currentRow, setCurrentRow] = useState<DepartmentDto>(new DepartmentDto());

    const [departments, setDepartments] = useState<Array<DepartmentDto>>([]);

    // key: id, value: DepartmentDto
    const [departmentMap, setDepartmentMap] = useState(new Map<string, DepartmentDto>());

    useEffect(() => {
        _fetchDepartments();
    }, []);

    const _fetchDepartments = async () => {
        const responseResult = await DepartmentApi.getDepartmentList();
        if (responseResult && responseResult.status === HttpStatus.SUCCESS) {
            // 构建部门的Map
            const departmentMap = new Map<string, DepartmentDto>();
            for (let item of responseResult.data) {
                departmentMap.set(item.id, item);
            }
            setDepartmentMap(departmentMap);

            setDepartments(DepartmentApi.constructDepartmentTree(responseResult.data));
        }
    };

    const handleClickRefresh = async () => {
        _fetchDepartments();
    };

    const _handleClickAdd = () => {
        const department = new DepartmentDto();
        setCurrentRow(department);
        setOpenDetailDialog(true);
    }

    const _handleClickModify = async (record: DepartmentDto) => {
        const responseResult = await DepartmentApi.getDepartmentDetail(record.id);
        if (responseResult.status === HttpStatus.SUCCESS) {
            setCurrentRow(responseResult.data);
            setOpenDetailDialog(true);
        }
    }

    const _handleClickDelete = async (record: DepartmentDto) => {
        confirm({title: intl.formatMessage({id: 'COMMON_DELETE_CONFIRM'})})
            .then(async () => {
                const responseResult = await DepartmentApi.deleteDepartment(record.id);
                if (responseResult.status === HttpStatus.SUCCESS) {
                    MessageUtils.success(intl.formatMessage({id: 'COMMON_DELETE_SUCCESS'}));
                    _fetchDepartments();
                }
            })
            .catch(() => {
                console.log('cancel');
            });
    };

    const _renderChildren = (children: Array<DepartmentDto>, level: number) => {
        return (
            <List component="div" disablePadding>
                {
                    children.map((child, index) => {
                        return (
                            <div key={child.id}>
                                <ListItemButton key={child.id} sx={{pl: 4 * level}}>
                                    <ListItemText primary={child.name} secondary={child.code}/>
                                    <Stack direction={'row'} spacing={1}>
                                        <a href={'javascript:void(0)'} onClick={() => _handleClickModify(child)}>
                                            <FormattedMessage id={'COMMON_MODIFY'}/>
                                        </a>
                                        <a href={'javascript:void(0)'} onClick={() => _handleClickDelete(child)}>
                                            <FormattedMessage id={'COMMON_DELETE'}/>
                                        </a>
                                    </Stack>
                                </ListItemButton>
                                {child.children ? _renderChildren(child.children, level + 1) : null}
                            </div>
                        )
                    })
                }
            </List>
        )
    }

    return (
        <div>
            <DepartmentDetailDialog open={openDetailDialog} department={currentRow} departments={departments}
                                    departmentMap={departmentMap}
                                    onClose={() => setOpenDetailDialog(false)}
                                    onOk={() => _fetchDepartments()}/>
            <Card>
                <CardHeader
                    title={intl.formatMessage({id: 'ACCOUNT_DEPARTMENT_MANAGEMENT'})}
                    action={
                        <div>
                            <AddIconButton onClick={_handleClickAdd}/>
                            <RefreshIconButton onClick={handleClickRefresh}/>
                        </div>
                    }
                />
                <CardContent>
                    <List>
                        {
                            departments.map((item, index) => {
                                return (
                                    <div key={item.id}>
                                        <ListItemButton>
                                            <ListItemText primary={item.name} secondary={item.code}/>
                                            <Stack direction={'row'} spacing={1}>
                                                <a href={'javascript:void(0)'} onClick={() => _handleClickModify(item)}>
                                                    <FormattedMessage id={'COMMON_MODIFY'}/>
                                                </a>
                                                <a href={'javascript:void(0)'} onClick={() => _handleClickDelete(item)}>
                                                    <FormattedMessage id={'COMMON_DELETE'}/>
                                                </a>
                                            </Stack>
                                        </ListItemButton>
                                        {item.children ? _renderChildren(item.children, 1) : null}
                                        <Divider sx={{mt: 2, mb: 2}}/>
                                    </div>
                                )
                            })
                        }
                    </List>
                </CardContent>
            </Card>
        </div>
    );
}